import * as React from 'react';
import Area from '@/components/Area';
import { Canvas, GroupProps, useGraph } from '@react-three/fiber';
import { OrbitControls, useGLTF, useTexture } from '@react-three/drei';
import glb from './stacy.glb';
import jpg from './stacy.texture.glb';
import { SkeletonUtils } from 'three-stdlib';
import { SkinnedMesh, Vector4 } from 'three';

function Model({ ...props }: { pose: number } & GroupProps) {
  const { scene } = useGLTF(glb);
  const clone = React.useMemo(() => SkeletonUtils.clone(scene), [scene]);
  const { nodes } = useGraph(clone);
  const stacy = nodes.stacy as SkinnedMesh;
  const texture = useTexture(jpg);
  texture.flipY = false;
  return (
    <group {...props}>
      {/* <primitive object={nodes.mixamorigHips} /> */}
      <skinnedMesh
        castShadow
        receiveShadow
        geometry={stacy.geometry}
        skeleton={stacy.skeleton}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[0.01, 0.01, 0.01]}
      >
        <primitive object={nodes.mixamorigHips} />
        <meshStandardMaterial map={texture} />
      </skinnedMesh>
    </group>
  );
}

export type Props = {};

function App01(props: Props) {
  const {} = props;

  return (
    <Area css={{ height: '400px' }}>
      {() => (
        <>
          <Canvas shadows camera={{ position: [1, 1.5, 2.5], fov: 50, viewport: new Vector4(0, 600, 0, 0) }}>
            {/* <Canvas shadows> */}
            <ambientLight intensity={0.5} />
            <directionalLight
              position={[-5, 5, 5]}
              castShadow
              shadow-mapSize-width={1024}
              shadow-mapSize-height={1024}
            />
            {/* <Bounds fit clip observe> */}
            {/* <PivotControls>
              <mesh>
                <boxGeometry args={[1, 1, 1]} />
              </mesh>
            </PivotControls> */}
            <group position={[0, -1, 0]}>
              <React.Suspense fallback={null}>
                <Model pose={4} position={[0, 0, 0]} />
              </React.Suspense>
            </group>
            {/* </Bounds> */}
            <mesh rotation={[-0.5 * Math.PI, 0, 0]} position={[0, -1, 0]} receiveShadow>
              <planeGeometry args={[10, 10, 1, 1]} />
              <shadowMaterial transparent opacity={0.2} />
            </mesh>
            <gridHelper />
            <axesHelper />
            {/* <perspectiveCamera position={[1, 1.5, 2.5]} fov={50} /> */}
            <OrbitControls makeDefault />
          </Canvas>
        </>
      )}
    </Area>
  );
}

export default React.memo(App01);
